var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login-title"},[_vm._v("您還未登入會員")]),_c('a',{attrs:{"href":_vm.lineLoginUrl}},[_c('img',{attrs:{"src":require("@/images/btn-login-base@2x.jpg"),"alt":"line"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }